var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconRepeatLoop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11L1.5 9L3.5 7L4.2 7.725L3.425 8.5H8.5V6.5H9.5V9.5H3.425L4.2 10.275L3.5 11ZM2.5 5.5V2.5H8.575L7.8 1.725L8.5 1L10.5 3L8.5 5L7.8 4.275L8.575 3.5H3.5V5.5H2.5Z",
    fill: "#09090A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconRepeatLoop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-repeat-loop.16e4d356acba06725d4a27b634c0dd34.svg";